export default __webpack_public_path__ + "static/media/Becky.c4131487.png";